import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from '../../store/actions';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const setSnackbarBackground = (type="info") => {
    switch(type) {
        case "danger":
            return "#F44336";
        case "warning":
            return "#FF9800";
        case "success":
            return "#4CAF50";
        case "info":
            return "#A3A0FB";
        default:
            return "#A3A0FB";
    }
};

class RequestSnackbar extends React.Component {

    onCloseHandler() {
        this.props.closeSnackbar();
    }

    render() {
        const { isOpen, message, type } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                open={isOpen}
                onClose={this.onCloseHandler.bind(this)}
                autoHideDuration={5000}
            >
                <SnackbarContent
                    style={{backgroundColor: setSnackbarBackground(type)}}
                    message={message}
                    onClose={this.onCloseHandler.bind(this)}
                    action={
                        <React.Fragment>
                        <IconButton
                            key="close"
                            aria-label="close"
                            size="small"
                            color="inherit"
                            onClick={this.onCloseHandler.bind(this)}
                        >
                            <CloseIcon />
                        </IconButton>
                        </React.Fragment>
                        }
                    />
            </Snackbar>
        );
    }
}

const mapStateToProps = state => {
    return {
        isOpen: state.requestReducer.isSnackbar,
        message: state.requestReducer.snackBarMessage
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

RequestSnackbar.propTypes = {
    type: PropTypes.string,
    //redux
    isOpen: PropTypes.bool,
    message: PropTypes.string,
    closeSnackbar: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestSnackbar);